import React from 'react';

import { Modal, Button, Text } from '@unimed-fesp/components';

import theme from '../../../styles/theme';

function ModalLiberarAcesso({
  isOpen,
  onClick,
  liberarAcesso,
  naoLiberarAcesso,
  isEditar,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClick={onClick}
      height={345}
      width={460}
      tipo="warning"
      footer={
        <ModalFooter
          naoLiberarAcesso={naoLiberarAcesso}
          isEditar={isEditar}
          liberarAcesso={liberarAcesso}
        />
      }
    >
      <Text
        font="300 14px 'work_sans'"
        color={theme.titleGray}
        center
        marginTop={28}
        marginBottom={37}
        text="Deseja liberar o acesso desse usuário?"
      />
    </Modal>
  );
}

const ModalFooter = ({ naoLiberarAcesso, isEditar, liberarAcesso }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={naoLiberarAcesso}
        marginRight={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        agora não
      </Button>
      <Button
        tipo="primary"
        onClick={liberarAcesso}
        marginLeft={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        sim
      </Button>
    </>
  );
};

export default ModalLiberarAcesso;
